<script setup lang="ts" name="InfiniteScrollLoading">
import Icon from '~/components/Icon.vue';

const { heightFull } = defineProps<{
  heightFull?: boolean;
}>();
</script>

<template>
  <div
    class="flex w-full items-center justify-center"
    :class="heightFull ? 'h-full' : 'py-4'"
  >
    <div
      class="flex flex-col items-center justify-center space-y-2 text-secondary-3"
    >
      <Icon icon="mdi:loading" size="3xl" class="animate-spin" />
      <p>Loading...</p>
    </div>
  </div>
</template>
